$(document).ready(function() {
	if ($('.js-ratingStars').length > 0) {
		$('.js-ratingStars').rating({
			hoverOnClear: false,
			theme: 'krajee-fa'
		});
	}

	// SLIDERS
	$('.js-sliderBanner').length && $('.js-sliderBanner').slick({
		autoplay: true,
		infinity: true,
		autoplaySpeed: 8000,
		speed: 1000,
		fade: false,
		arrows: false,
		dots: true,
		mobileFirst: true,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					arrows: true
				}
			}
		]
	});
	$('.js-slider4').length && $('.js-slider4').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinity: true,
		speed: 1000,
		arrows: true,
		mobileFirst: true,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4
				}
			},
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 4
				}
			}
		]
	});
	if ($('.js-sliderSync1').length) {
		$('.js-sliderSync1').slick({
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			fade: true,
			asNavFor: '.js-sliderSync2',
			adaptiveHeight: true
		});
		$('.js-sliderSync2').slick({
			infinite: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			asNavFor: '.js-sliderSync1',
			focusOnSelect: true,
			arrows: true,
			vertical: true,
			mobileFirst: true,
			swipe: false,
			responsive: [
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 4
					}
				},
				{
					breakpoint: 1023,
					settings: {
						slidesToShow: 8
					}
				}
			]
		});
	}

	// NAVIGATION TRIGGER
	$('.js-navTrigger').on('click', function() {
		$('body').toggleClass('nav-opened');
		$('.js-nav').toggleClass('opened');
		$('.js-nav').animate({scrollTop: 0}, 0)
	});

	// NAVIGATION TRIGGER
	$('.js-searchTrigger').on('click', function() {
		$('body').toggleClass('nav-opened');
		$('.js-search').toggleClass('opened');
	});

	// PRODUCTS FITER
	$('.js-filterOpen').on('click', function() {
		$('body').toggleClass('nav-opened');
		$('.js-filter').toggleClass('opened');
	});
	$('.js-filterClose').on('click', function() {
		$('body').removeClass('nav-opened');
		$('.js-filter').removeClass('opened');
	});

	// PRODUCTS QUANTITY
	$('.js-quanTrigger').on('click', function() {
		let button = $(this),
			parent = button.closest('.js-quantity'),
			value = parent.find('.js-quanValue')
		quantityTrigger(button, value);
	});

	// SHOPPING CART ASIDE
	$('.js-cartAsideOpen').on('click', function() {
		let body = $('body'),
			target = $('.js-cartAside');
		body.addClass('nav-opened');
		target.addClass('opened');
	});

	// REMOVE ITEM FROM SHOPPING CART
	$('.js-removeFromCart').on('click', function() {
		let item = $(this).closest('.item');
		item.remove();
	});

	// REMOVE HEADER AND FOOTER FOR PURCHASE
	if ($('.js-emptyLayout').length) {
		$('.topbar').remove();
		$('.header').remove();
		$('.footer').remove();
	}

	// TAB NAVIGATION
	$('.js-tabLink').on('click', function() {
		var target = $(this).data('target'),
			parent = $(this).closest('.js-tabParent');

		parent.find('.js-tabNav .js-tabLink').removeClass('active');
		parent.find('.js-tabContent .tab-panel').removeClass('active');
		$(target).addClass('active');
		$(this).addClass('active');
	});
	
	//SMOOTSCROLL
	$('.js-pageDirectionTrigger').on('click', function() {
		var elem = $(this),
			header = $('.header'),
			parent = $('.js-pageDirection');
		smoothScroll(elem,header);
		parent.find('.js-pageDirectionTrigger').removeClass('active');
		$(this).addClass('active');
	});

	$('.js-productColor').on('mouseover touchend click', function(e) {
		e.preventDefault();
		let parent = $(this).closest('.inner'),
			imgUrlBack = $(this).data('img-back'),
			imgUrlFront = $(this).data('img-front'),
			imgBack = parent.find('.js-imgBack'),
			imgFront = parent.find('.js-imgFront');
		parent.find('.js-productColor').removeClass('active');
		$(this).addClass('active');
		imgBack.attr('src', imgUrlBack);
		imgFront.attr('src', imgUrlFront);
	});

	// PRODUCT DETAIL COLOR CHANGE
	$('.js-colorChange').on('touchend click', function() {
		let value = $(this).data('value'),
			parent = $('.js-form'),
			colorText = parent.find('.js-colorAfterChange'),
			colorValue = parent.find('.js-colorValue');

		colorText.html(value);
		colorValue.val(value);
		$(this).addClass('active');
		$(this).siblings().removeClass('active');
	});
});
